import Client from './client';

export default class UserProductDetailSettings extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/courthouse/${organization}/setting/product/details`, options);
  }

  put(organization, options = {}) {
    return this.makeRequest(`${this.host}/courthouse/${organization}/setting/product/details`, {
      ...options,
       method: 'PUT',
    });
  }

  delete(organization, options = {}) {
    return this.makeRequest(`${this.host}/courthouse/${organization}/setting/product/details`, {
      ...options,
       method: 'DELETE',
    });
  }

}
